/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DeleteLockConfigRuleRequest {
    getFixupPrototypeFunction() { return DeleteLockConfigRuleRequest.fixupPrototype; }

    static newInstance(model: Partial<DeleteLockConfigRuleRequest>): DeleteLockConfigRuleRequest {
        let obj = Object.assign(new DeleteLockConfigRuleRequest(), model);
        DeleteLockConfigRuleRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DeleteLockConfigRuleRequest>): DeleteLockConfigRuleRequest {
        if (!model) return null;
        return DeleteLockConfigRuleRequest.newInstance(<DeleteLockConfigRuleRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DeleteLockConfigRuleRequest) {
        if (!obj) return;

        models.DeleteLockConfigRuleRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DeleteLockConfigRuleRequest): boolean {
        Object.setPrototypeOf(obj, DeleteLockConfigRuleRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Config rule id, it can be fetched from List Resource Lock Config Rules API
     */
    config_rule_id: string;

}
